/* eslint-disable */

import React, { Component } from 'react';
import LinkAccount from './components/01_LinkAccount';
import Domains from './components/02_Domains';
import ActivateDomains from './components/03_ActivateDomains';
import AddUsers from './components/04_AddUsers';
import TrackGoogleDiscover from './components/06_TrackGoogleDiscover';
import AuthorReports from './components/07_AuthorReports';
import BrandedTerms from './components/08_BrandedTerms';
import SearchBehavior from './components/10_SearchBehavior';
import AddTaxIdOrVat from './components/10_AddTaxIdOrVat';
import AddAdditionalEmails from './components/05_AddAdditionalEmails';
import { withTranslation } from 'react-i18next';
import { getGeoLocations, getOnboardingInfoQuery, skipOnboardingQuery } from './query';
import { showMessage } from '../../helpers/showMessage';
import Loading from '../../components/Loading';
// import AdditionalAddOns from './components/AdditionalAddOns';

// Steps that only make sense with Search or Discover Analytics: picking GSC
// domains, activating them for the trial, author reports, branded terms and
// search behavior. Users on a plan without either product never see them, and
// the remaining steps are renumbered.
const ANALYTICS_ONLY_STEPS = [2, 3, 6, 7, 8];

function getIsEmptyProfile(obj) {
    for (let key in obj) {
        if (obj[key]) return false;
    }
    return true;
}

class Onboarding extends Component {
    constructor(props) {
        super();

        this.showOpened = this.showOpened.bind(this);
        this.onClickOnStep = this.onClickOnStep.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.selectAccount = this.selectAccount.bind(this);
        this.onAddUsers = this.onAddUsers.bind(this);
        this.finishSteps = this.finishSteps.bind(this);
        this.isDisabled = this.isDisabled.bind(this);
        this.getOnboardingData = this.getOnboardingData.bind(this);
        this.skipOnboarding = this.skipOnboarding.bind(this);
        this.getPermissions = this.getPermissions.bind(this);

        this.domains = JSON.parse(props.domains);
        this.profile = JSON.parse(props.profile);
        this.available_accounts = JSON.parse(props.available_accounts);

        this.isActiveDomain = this.domains?.find((item) => item.status);
        this.isEmptyProfile = getIsEmptyProfile(this.profile);

        const isDisableAccountPart =
            !window.user_permissions?.discover_analytics &&
            !window.user_permissions?.search_analytics;

        this.isAiTrackingActive = window.user_permissions?.ai_tracking;
        const isFinished = (this.isActiveDomain || isDisableAccountPart) && !this.isEmptyProfile;
        const alreadySelectedAccountId = localStorage.getItem('onboarding_account_id');
        let alreadySelectedAccount = null;
        if (alreadySelectedAccountId) {
            alreadySelectedAccount = this.available_accounts.find(
                (item) => item.account_id === alreadySelectedAccountId,
            );
        }

        this.users_remaining_count = window.user_permissions?.seats
            ? window.user_permissions.seats?.total - window.user_permissions?.used?.seats
            : Number(props.users_remaining_count) ?? 0;

        this.users_total_number_of_available = window.user_permissions?.seats
            ? window.user_permissions?.seats?.total
            : Number(props.users_total_number_of_available) ?? 0;

        this.state = {
            allData: [],
            isLoading: true,
            selectedCollapse: isFinished
                ? 0
                : !isDisableAccountPart && this.domains?.length > 0
                ? 3
                : 1,
            paymentInformation: null,
            selectedAccount: alreadySelectedAccount,
            users_remaining_count: this.users_remaining_count,
            users_total_number_of_available: this.users_total_number_of_available,
            isFinished,
            geolocation: [],
            onboardingInfo: null,
            isLoadingSkipOnboarding: false,
            isAiTrackingActive: this.isAiTrackingActive,
            isDisableAccountPart,
        };
    }

    async getOnboardingData() {
        try {
            const res = await getOnboardingInfoQuery();
            const data = await res.json();
            this.setState({
                onboardingInfo: data,
            });
        } catch (err) {
            showMessage(err?.message ?? this.props.t('global.something_went_wrong'), 'error');
        }
    }

    async skipOnboarding() {
        try {
            this.setState({ isLoadingSkipOnboarding: true });
            const res = await skipOnboardingQuery({ onboarding_skipped: true, need_onboard: true });
            const data = await res.json();
            if (res.status === 200) {
                window.location.href = '/';
            } else {
                this.setState({ isLoadingSkipOnboarding: false });
                showMessage(data?.detail ?? this.props.t('global.something_went_wrong'), 'error');
            }
        } catch (err) {
            this.setState({ isLoadingSkipOnboarding: false });
            showMessage(err?.message ?? this.props.t('global.something_went_wrong'), 'error');
        }
    }

    async componentDidMount() {
        try {
            document.addEventListener('getPermissionsEvent', this.getPermissions);
            this.getOnboardingData();
            const res = await getGeoLocations();
            const data = await res.json();
            this.setState({
                geolocation: data?.map((item) => ({ value: item.geo, label: item.location })) || [],
            });
        } catch (err) {
            console.log(err);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('getPermissionsEvent', this.getPermissions);
    }

    async getPermissions() {
        try {
            const data = window.user_permissions || {};

            const isDisableAccountPart = !data?.discover_analytics && !data?.search_analytics;

            const isAiTrackingActive = data?.ai_tracking;
            const isFinished =
                (this.isActiveDomain || this.state?.isDisableAccountPart) && !this.isEmptyProfile;

            this.users_remaining_count = data?.seats
                ? data?.total - data?.used?.seats
                : Number(this.props.users_remaining_count) ?? 0;

            this.users_total_number_of_available = data?.seats
                ? data?.total
                : Number(this.props.users_total_number_of_available) ?? 0;

            const isOpenedStepHidden =
                isDisableAccountPart && ANALYTICS_ONLY_STEPS.includes(this.state.selectedCollapse);

            this.setState({
                users_remaining_count: this.users_remaining_count,
                users_total_number_of_available: this.users_total_number_of_available,
                isFinished,
                isAiTrackingActive,
                isDisableAccountPart,
                ...(isOpenedStepHidden ? { selectedCollapse: 1 } : {}),
            });
        } catch (err) {
            console.log(err);
        }
    }

    selectAccount(account) {
        localStorage.setItem('onboarding_account_id', account.account_id);
        this.setState({
            selectedAccount: account,
        });
        this.handleNext(1); // current step is 1
    }

    onClickOnStep(id) {
        this.setState({
            selectedCollapse: this.state.selectedCollapse === id ? null : id,
        });
    }

    showOpened(name, value) {
        return this.state.selectedCollapse === name ? value ?? 'active' : '';
    }

    handleNextStep(id) {
        this.handleNext(id);
    }

    handleNext(id) {
        const index = this.data.findIndex((item) => item.id === id);
        const nextStep = this.data[index + 1];
        if (!nextStep) return;
        this.setState({
            selectedCollapse: nextStep.id,
        });
    }

    handleBack(id) {
        const index = this.data.findIndex((item) => item.id === id);
        const prevStep = index > 0 ? this.data[index - 1] : null;
        if (!prevStep) return;
        this.setState({
            selectedCollapse: prevStep.id,
        });
    }

    onAddUsers(count) {
        this.setState({
            users_remaining_count: this.state.users_remaining_count - count,
        });
    }

    finishSteps() {
        skipOnboardingQuery({ onboarding_skipped: false, need_onboard: false });
        this.setState({
            isFinished: true,
            selectedCollapse: 0,
        });
        setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 100);
    }

    isDisabled(id) {
        switch (id) {
            case 1:
                return false;
            case 2: {
                if (
                    this.available_accounts.length === 0 ||
                    (!this.state.selectedAccount && this.domains.length === 0)
                )
                    return true;
                return false;
            }
            case 3: {
                if (this.state.isDisableAccountPart) return true;
                if (this.domains.length === 0) return true;
                return false;
            }
            case 6: {
                if (this.state.isDisableAccountPart) return true;
                if (
                    this.available_accounts.length === 0 ||
                    this.domains.length === 0 ||
                    !this.domains.find((item) => item.status)
                )
                    return true;
                return false;
            }
            case 4:
            case 5:
            case 7:
            case 8:
            case 9:
            case 10: {
                if (this.state.isDisableAccountPart) return false;
                if (
                    this.available_accounts.length === 0 ||
                    this.domains.length === 0 ||
                    !this.domains.find((item) => item.status)
                )
                    return true;
                return false;
            }
            default: {
                return false;
            }
        }
    }

    render() {
        const { t } = this.props;
        const usersCount = this.users_total_number_of_available - this.users_remaining_count;

        const steps = [
            {
                id: 1,
                name: (
                    <>
                        <div>
                            <div>{t('onboarding.step_1.header')}</div>
                            <div className="onboarding-container-item-body-header-subtitle">
                                {t('onboarding.step_1.subheader')}
                            </div>
                        </div>
                        <a
                            href="/customers/link?gd_src=from_onboard"
                            className={`button button-primary ${
                                this.available_accounts.length ? 'button-outline' : 'button-filled'
                            }`}
                        >
                            {this.available_accounts.length
                                ? t('onboarding.step_1.add_additional_gcs_account')
                                : t('onboarding.step_1.connect_gsc_account')}
                        </a>
                    </>
                ),
                component: (
                    <LinkAccount
                        account={this.props.gd_src}
                        domains={this.domains}
                        available_accounts={this.available_accounts}
                        csrf_token={this.props.csrf_token}
                        selectAccount={this.selectAccount}
                    />
                ),
            },
            {
                id: 2,
                name: (
                    <div>
                        <div>{t('onboarding.step_2.header')}</div>
                        <div className="onboarding-container-item-body-header-subtitle">
                            {t('onboarding.step_2.subheader')}
                        </div>
                    </div>
                ),
                component: (
                    <Domains
                        csrf_token={this.props.csrf_token}
                        domains={this.domains}
                        selectedAccount={this.state.selectedAccount}
                        handleNext={() => this.handleNext(2)}
                        handleBack={() => this.handleBack(2)}
                        // isDisabledNext={this.isDisabled(3)}
                    />
                ),
            },
            {
                id: 3,
                name: (
                    <div>
                        <div>{t('onboarding.step_3.header')}</div>
                        <div className="onboarding-container-item-body-header-subtitle">
                            {t('onboarding.step_3.subheader_1')}
                        </div>
                    </div>
                ),
                component: (
                    <ActivateDomains
                        domains={this.domains}
                        csrf_token={this.props.csrf_token}
                        handleNext={() => this.handleNextStep(3)}
                        handleBack={() => this.handleBack(3)}
                        isDisabledNext={this.isDisabled(4)}
                    />
                ),
            },
            {
                id: 4,
                name: (
                    <div>
                        <div>{t('onboarding.step_4.header')}</div>
                        <div className="onboarding-container-item-body-header-subtitle">
                            {t('onboarding.step_4.subheader_1', {
                                usersCount: usersCount,
                                users_total_number_of_available:
                                    this.users_total_number_of_available,
                            })}
                        </div>
                        <div className="onboarding-container-item-body-header-subtitle">
                            {t('onboarding.step_4.subheader_2')}
                        </div>
                    </div>
                ),
                component: (
                    <AddUsers
                        domains={this.domains}
                        csrf_token={this.props.csrf_token}
                        users_remaining_count={this.state.users_remaining_count}
                        users_total_number_of_available={this.state.users_total_number_of_available}
                        onAddUsers={this.onAddUsers}
                        handleNext={() => this.handleNext(4)}
                        handleBack={() => this.handleBack(4)}
                    />
                ),
            },
            {
                id: 5,
                name: (
                    <div>
                        <div>{t('onboarding.step_5.header')}</div>
                        <div className="onboarding-container-item-body-header-subtitle">
                            {t('onboarding.step_5.subheader')}
                        </div>
                    </div>
                ),
                component: (
                    <AddAdditionalEmails
                        domains={this.domains}
                        csrf_token={this.props.csrf_token}
                        users_remaining_count={this.state.users_remaining_count}
                        users_total_number_of_available={this.state.users_total_number_of_available}
                        onAddUsers={this.onAddUsers}
                        handleNext={() => this.handleNext(5)}
                        handleBack={() => this.handleBack(5)}
                    />
                ),
            },
            {
                id: 6,
                name: (
                    <div>
                        <div>{t('onboarding.step_6.header')}</div>
                        <div className="onboarding-container-item-body-header-subtitle">
                            <div>{t('onboarding.step_6.subheader')}</div>
                        </div>
                    </div>
                ),
                component: (
                    <AuthorReports
                        csrf_token={this.props.csrf_token}
                        handleNext={() => this.handleNext(6)}
                        handleBack={() => this.handleBack(6)}
                    />
                ),
            },
            {
                id: 7,
                name: (
                    <div>
                        <div>{t('onboarding.step_7.header')}</div>
                        <div className="onboarding-container-item-body-header-subtitle">
                            {t('onboarding.step_7.subheader')}
                        </div>
                    </div>
                ),
                component: (
                    <BrandedTerms
                        domains={this.domains}
                        csrf_token={this.props.csrf_token}
                        handleNext={() => this.handleNext(7)}
                        handleBack={() => this.handleBack(7)}
                    />
                ),
            },
            {
                id: 8,
                name: (
                    <div>
                        <div>{t('onboarding.step_8.header')}</div>
                        <div className="onboarding-container-item-body-header-subtitle">
                            {t('onboarding.step_8.subheader')}
                        </div>
                    </div>
                ),
                component: (
                    <SearchBehavior
                        domains={this.domains}
                        csrf_token={this.props.csrf_token}
                        handleNext={() => this.handleNext(8)}
                        handleBack={() => this.handleBack(8)}
                    />
                ),
            },
            {
                id: 9,
                name: (
                    <div>
                        <div>{t('onboarding.step_9.header')}</div>
                        <div className="onboarding-container-item-body-header-subtitle">
                            {t('onboarding.step_9.subheader')}
                        </div>
                    </div>
                ),
                component: (
                    <AddTaxIdOrVat
                        csrf_token={this.props.csrf_token}
                        tax_id_types={this.props.tax_id_types}
                        handleNext={() => this.handleNext(9)}
                        handleBack={() => this.handleBack(9)}
                        profile={this.profile}
                        company={this.props.company}
                        finishSteps={this.finishSteps}
                        geolocation={this.state.geolocation}
                    />
                ),
            },
        ];

        this.data = this.state.isDisableAccountPart
            ? steps.filter((item) => !ANALYTICS_ONLY_STEPS.includes(item.id))
            : steps;

        return (
            <>
                <div className="onboarding-container">
                    <div className="onboarding-container-header">
                        <h2 className="d-flex gap-8 align-items-center justify-content-between">
                            {t('onboarding.header')}{' '}
                            {this.state.onboardingInfo?.need_onboard &&
                                !this.state.onboardingInfo?.onboarding_skipped &&
                                !this.state.isFinished && (
                                    <button
                                        className="button button-primary button-filled onboarding-container-header-skip d-flex gap-8 align-items-center"
                                        onClick={this.skipOnboarding}
                                        disabled={this.state.isLoadingSkipOnboarding}
                                    >
                                        {this.state.isLoadingSkipOnboarding && (
                                            <Loading onlyPreloader />
                                        )}
                                        Skip Onboarding, Will Do Later{' '}
                                    </button>
                                )}
                        </h2>
                        <div>{t('onboarding.subheader')}</div>
                    </div>

                    {this.state.isFinished && (
                        <div className="onboarding-all-done-box">
                            <div className="onboardin-card">
                                <img src="/static/img/onboarding-all-done.svg" alt="all-done-img" />
                                <div>
                                    <div className="onboarding-all-done-box-header">
                                        {t('onboarding.finish.header')}
                                    </div>
                                    <div className="onboarding-all-done-box-body">
                                        {t('onboarding.finish.subheader.message_1')}{' '}
                                        <strong>
                                            {t('onboarding.finish.subheader.message_2')}
                                        </strong>{' '}
                                        {t('onboarding.finish.subheader.message_3')}{' '}
                                        {this.state.isAiTrackingActive && (
                                            <a href="/ai-tracking/prompt-generator/" className="ml-5">
                                                {t(
                                                    'onboarding.finish.subheader.message_ai_tracking',
                                                )}{' '}
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {this.data.map((item, index) => (
                        <div
                            className="onboarding-container-item"
                            key={item.id}
                            style={{
                                opacity:
                                    this.isDisabled(item.id) || this.state.isFinished ? '0.3' : '1',
                            }}
                        >
                            <div className={`onboarding-container-item-number`}>{index + 1}</div>
                            <div className="onboarding-container-item-body">
                                <div
                                    className={`onboarding-container-item-body-header ${this.showOpened(
                                        item.id,
                                        'show',
                                    )}`}
                                    onClick={() =>
                                        !(this.state.isFinished || this.isDisabled(item.id))
                                            ? this.onClickOnStep(item.id)
                                            : null
                                    }
                                >
                                    <div className="onboarding-container-item-body-header-left">
                                        {item.name}
                                    </div>
                                    <button className="arrow-icon">
                                        <i className="icon-chevron-right" />
                                    </button>
                                </div>
                                <div
                                    className={`onboarding-container-item-body-content ${this.showOpened(
                                        item.id,
                                        'show',
                                    )}`}
                                >
                                    {item.component ?? t('onboarding.in_process')}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </>
        );
    }
}

export default withTranslation()(Onboarding);
